import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { TeamSettingsModal } from "./team-settings-modal";
const routes: Routes = [
    { path: '', loadComponent: () =>
      import('./team-settings-modal').then(m => m.TeamSettingsModal)
    }
  ];
@NgModule({
    declarations: [
      TeamSettingsModal
    ],
    imports: [
        IonicModule,
        HttpClientModule,
        SharedModule,
        CommonModule,
        TranslateModule,
        RouterModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class TeamSettingsModalModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }